// Use Horizon's menu sizing/overflow controller, with hover, touch and keyboard controls.
const itemSelector = '[data-tn-brand-item]';
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
let activeItem = null;
let closeTimer;
let pinned = false;

function controller(item) {
  return item?.closest('header-menu');
}

function open(item) {
  clearTimeout(closeTimer);
  const menu = controller(item);
  if (!menu || typeof menu.activate !== 'function') return;
  if (activeItem && activeItem !== item) close();
  activeItem = item;
  item.querySelector('.tn-brand-submenu')?.removeAttribute('inert');
  menu.activate({ target: item });
}

function close(restoreFocus = false) {
  clearTimeout(closeTimer);
  if (!activeItem) return;
  const item = activeItem;
  // Restore focus before collapsing: the resulting focusin must not reopen the panel.
  if (restoreFocus) item.querySelector('[data-tn-brand-toggle]')?.focus();
  controller(item)?.deactivate({ target: item, relatedTarget: null, type: 'pointerleave' });
  item.querySelector('.tn-brand-submenu')?.setAttribute('inert', '');
  activeItem = null;
  pinned = false;
}

await customElements.whenDefined('header-menu');

document.addEventListener('pointerover', (event) => {
  if (!canHover.matches || event.pointerType === 'touch') return;
  const item = event.target.closest?.(itemSelector);
  if (item && !item.contains(event.relatedTarget)) open(item);
  else if (!item && activeItem && event.target.closest?.('header-menu .menu-list__list-item')) close();
});

document.addEventListener('pointerout', (event) => {
  const item = event.target.closest?.(itemSelector);
  if (!item || item.contains(event.relatedTarget) || pinned) return;
  clearTimeout(closeTimer);
  closeTimer = setTimeout(() => {
    if (activeItem === item && !item.contains(document.activeElement)) close();
  }, 180);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest?.('[data-tn-brand-toggle]');
  if (toggle) {
    const item = toggle.closest(itemSelector);
    if (activeItem === item && pinned) close();
    else { open(item); pinned = true; }
  } else if (activeItem && !activeItem.contains(event.target)) {
    close();
  }
});

document.addEventListener('focusin', (event) => {
  const item = event.target.closest?.(itemSelector);
  if (item) open(item);
  else if (activeItem) close();
});

document.addEventListener('focusout', (event) => {
  if (activeItem?.contains(event.target) && !activeItem.contains(event.relatedTarget)) close();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && activeItem) {
    event.preventDefault();
    close(true);
  } else if (event.key === 'ArrowDown') {
    const toggle = event.target.closest?.('[data-tn-brand-toggle]');
    if (toggle) {
      event.preventDefault();
      const item = toggle.closest(itemSelector);
      open(item);
      item.querySelector('.tn-brand-submenu a')?.focus();
    }
  }
});

window.addEventListener('resize', () => close());
document.addEventListener('shopify:section:unload', () => close());
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.querySelector?.(itemSelector);
  if (item) open(item);
});
